module.exports = __webpack_public_path__ + "img/mm_b2_pic2.188793fd.png";